import moment from "moment";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";

import { RegionType } from "graphql/generated";
import { LANGUAGE_TO_COUNTRY } from "src/configs/common";
import {
  MMM_DATE_FORMAT_BY_COUNTRY_WITH_SPACE,
  MMM_WEEK_DAY_FORMAT_BY_COUNTRY,
  TIME_BY_COUNTRY
} from "src/constants/Common";

export const useFormatDate = () => {
  const { locale } = useRouter();
  const region: RegionType = useMemo(() => {
    return LANGUAGE_TO_COUNTRY[locale] || RegionType.Sg;
  }, [locale]);

  const formatDate = useCallback(
    (value: string | Date) => {
      return moment(value).format(MMM_DATE_FORMAT_BY_COUNTRY_WITH_SPACE[region]);
    },
    [region]
  );

  const formatDateWithDay = useCallback(
    (value: string | Date) => {
      return moment(value).format(MMM_WEEK_DAY_FORMAT_BY_COUNTRY[region]);
    },
    [region]
  );

  const formatTime = useCallback(
    (value: string | Date) => {
      return moment(value).format(TIME_BY_COUNTRY[region]);
    },
    [region]
  );

  const formatDateTime = useCallback(
    (value: string | Date) => {
      if (!value) {
        return "";
      }
      return `${moment(value).format(MMM_DATE_FORMAT_BY_COUNTRY_WITH_SPACE[region])}, ${moment(
        value
      ).format(TIME_BY_COUNTRY[region])}`;
    },
    [region]
  );

  return { formatDate, formatTime, formatDateWithDay, formatDateTime };
};
